import { defineStore } from 'pinia'
import type DialogTypes from '../types/Dialog'

interface Open {
  title: string
  message: string
  width?: number
  options?: {
    color: string
    width: number
    zIndex: number
  }
}

export const useDialog = defineStore('dialog', {
  state: () =>
    ({
      isOpen: false,
      resolve: null as ((value: boolean) => void | Promise<void>) | null,
      reject: null as ((value: boolean) => void | Promise<void>) | null,
      message: null as string | null,
      title: null as string | null,
      options: {
        color: 'secondary',
        width: 290,
        zIndex: 200,
      },
    } as DialogTypes),

  actions: {
    open({ title, message, options, width }: Open): Promise<unknown> {
      this.isOpen = true
      this.title = title
      this.message = message
      this.options.width = width ?? 290
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree(): void {
      if (this.resolve !== null) {
        this.resolve(true)
        this.isOpen = false
      }
    },
    cancel(): void {
      if (this.resolve !== null) {
        this.resolve(false)
        this.isOpen = false
      }
    },
  },
})
